import * as React from 'react'

import { css, Global, useTheme } from '@emotion/react'

import { Colors } from '../theme/colors'

interface Props {
  bodyBackground?: Colors
}

const GlobalStyles: React.FC<Props> = ({ bodyBackground = 'background' }) => {
  const theme = useTheme()
  return (
    <Global
      styles={css`
        * {
          font-family: 'Cash Sans', 'Helvetica Neue', helvetica, sans-serif;
        }

        html {
          box-sizing: border-box;
        }

        *,
        *::before,
        *::after {
          box-sizing: inherit;
        }

        body {
          background: ${theme.colors[bodyBackground]};
          color: ${theme.colors.body};
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;

          ${theme.typography.body};
          /* Resetting line-height to browser default to overwrite the line-height set in theme.typography.body
          * This is to ensure that the line-height is not inherited by non-text elements.
          */
          line-height: unset; /* stylelint-disable-line @cash-web/no-hardcoded-font-styles */
        }

        body,
        div,
        dl,
        dt,
        dd,
        ul,
        ol,
        li,
        h1,
        h2,
        h3,
        h4,
        h5,
        h6,
        pre,
        form,
        fieldset,
        input,
        textarea,
        p,
        blockquote,
        th,
        td,
        hr {
          margin: 0;
          padding: 0;
        }

        table {
          border-collapse: collapse;
          border-spacing: 0;
        }

        fieldset,
        img {
          border: 0;
        }

        address,
        caption,
        cite,
        code,
        dfn,
        em,
        th,
        var {
          font-style: normal;
          font-weight: normal; /* stylelint-disable-line @cash-web/no-hardcoded-font-styles */
        }

        strong,
        b {
          font-style: normal;
          font-weight: ${theme.weights.medium}; /* stylelint-disable-line @cash-web/no-hardcoded-font-styles */
        }

        ol,
        ul {
          list-style: none;
        }

        caption,
        th {
          text-align: left;
        }
      `}
    />
  )
}

export default GlobalStyles
